export default <T>(type) =>
  (payload?: T): { type: string; payload: T } => ({
    type,
    payload,
  });
